export const passwordFormField = {
  email: "email",
  password: "password",
  confirmPassword: "confirm-password",
};
